<template>
  <div class="wrapper">
    <div class="order-address" @click="goaddresslist">
      <div class="order-address-l">
        <!-- <div class="order-address-ll">
          <img src="../../assets/images/icon_xzshdz.svg" alt>
        </div>-->
        <div class="order-address-lr" v-show="addressNbr != ''">
          <p>
            <span>收货人：{{ address.contacts }}</span>
            <span>{{ address.phone_no }}</span>
          </p>
          <p class="order-address-text">
            {{ address.province || "" }}{{ address.city || ""
            }}{{ address.district || "" }} {{ address.address || "" }}
          </p>
        </div>
        <div class="order-address-lr" v-show="addressNbr == ''">
          <p class="order-address-text">
            您还没有设置收货地址，请先设置收货地址
          </p>
        </div>
      </div>
      <div class="order-address-r">
        <img src="../../assets/images/icon_youjiantou.svg" alt />
      </div>
    </div>
    <div class="addressLine">
      <img src="../../assets/images/pattern.jpg" alt />
    </div>
    <img class="card" src="../../assets/images/equity/equityCard.png" alt />

    <div class="btn" @click.stop="pay">
      <span>领取</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import weChatShareApi from "../../assets/js/weChatShare";
import { handleText } from "./../../assets/js/tool";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      address: {}, //地址
      addressNbr: "", // 默认地址编号
      paySwitch: true, // 订单生成开关
      goPaySwitch: true, //
      keepAlive: false,
    };
  },
  watch: {
    $route(to, from) {
      if (from.path == "/addresslist" || from.path == "/couponCommodity") {
        this.keepAlive = true;
      } else {
        this.keepAlive = false;
      }
    },
  },
  computed: {
    ...mapGetters(["selectaddress", "userInfo"]),
  },
  methods: {
    goaddresslist() {
      var address = 1;
      this.$router.push({
        path: "/addresslist",
        query: { address: address, supNbr: this.userInfo.nbr },
      });
    },
    pay() {
      if (this.addressNbr == "")
        return this.$toast({
          message: "请选择收货地址",
          duration: 2000,
        });
      let toast = this.$toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0,
      });
      if (!this.paySwitch) return false;
      this.paySwitch = false;
      let obj = {
        jydm: "flow_10105",
        flow_10105: {
          user_nbr: this.userInfo.nbr,
          address_nbr: this.addressNbr,
        },
      };
      this.$commonPost(obj)
        .then((response) => {
          toast.clear();
          this.paySwitch = true;
          this.$router.replace({
            path: "/equityResult",
          });
        })
        .catch((err) => {
          toast.clear();
          this.paySwitch = true;
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
    getAddress(resolve, reject) {
      // 用户的默认地址
      this.$commonPost({
        jydm: "flow_10010",
        flow_10010: {
          user_nbr: this.userInfo.nbr,
        },
      })
        .then((response) => {
          let obj = {};
          if (response.address) {
            obj = response.address;
            obj.address = handleText(obj.address);
            this.addressNbr = response.address.nbr;
            this.$store.commit("SENDselectaddress", obj);
          } else {
            this.addressNbr = "";
          }
          this.address = obj;
          resolve();
        })
        .catch((err) => {
          reject();
          this.$toast({
            message: err.message,
            duration: 2000,
          });
        });
    },
  },
  created() {
    document.title = "提交订单";
  },
  mounted() {
    document.title = "提交订单";
  },
  activated() {
    document.title = "提交订单";
    let option = {
      title: "有米@" + this.userInfo.name + "的店铺",
      desc: "欢迎光临我的店铺",
      link: location.origin + "/?supNbr=" + this.userInfo.nbr,
      images: this.userInfo.imgUrl,
    };
    this.weChatShare(option);

    this.paySwitch = true;
    let that = this;
    async function getAddress() {
      return new Promise((resolve, reject) => {
        that.getAddress(resolve, reject);
      });
    }
    async function getAllData() {
      if (that.selectaddress) {
        that.address = that.selectaddress;
        that.addressNbr = that.selectaddress.nbr;
      } else {
        await getAddress();
      }
    }
    getAllData();
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name == "equityDetail" ||
      to.name == "cart" ||
      to.name == "myorder" ||
      to.name == "purchaseCommdity"
    ) {
      this.$store.commit("SENDselectaddress", "");
    }
    next();
  },
  destroyed() {},
};
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
.addressLine {
  width: 100%;
  height: 0.06rem;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: 0.06rem;
  }
}
.wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f7f7f7;
  padding-bottom: 1.08rem;
  box-sizing: border-box;
}
.order-address {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.32rem 0.24rem;
  background: #fff;
  height: 1.16rem;
  align-items: center;
}
.order-address-lr {
  position: relative;
}
.order-address-l {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.order-address-l p {
  font-size: 0.28rem;
  color: #333333;
}
.order-address-l p > span:nth-child(1) {
  width: 3.68rem;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-all;
  margin-bottom: 0.2rem;
  line-height: 0.33rem;
}
.order-address-l p > span:nth-child(2) {
  position: absolute;
  top: 0;
  left: 3.96rem;
}
.order-address-r {
  line-height: 1.2rem;
}
.order-address-text {
  width: 5.5rem;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
  line-height: 0.32rem;
}
.toAddressInfo {
  min-height: 0.2rem;
  box-sizing: border-box;
  padding: 0 0.24rem;
  .main {
    display: flex;
    height: 0.76rem;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 0.34rem;
        height: 0.34rem;
        margin-right: 0.1rem;
      }
      span {
        color: #e52b25;
        font-size: 0.24rem;
        font-weight: 500;
      }
    }
    .right {
      width: 1.26rem;
      height: 0.4rem;
      border-radius: 0.2rem;
      border: 1px solid #e52b25;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        color: #e52b25;
        font-size: 0.24rem;
        font-weight: 500;
        line-height: 0;
      }
    }
  }
}
.card {
  width: 7.06rem;
  height: 3.36rem;
  margin-top: 0.22rem;
  margin-left: 0.22rem;
}
.btn {
  position: fixed;
  bottom: 0.12rem;
  left: 0.3rem;
  width: 6.9rem;
  height: 0.88rem;
  border-radius: 0.44rem;
  background: #e52b25;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    font-size: 0.3rem;
    color: #fff;
    font-weight: bold;
  }
}
</style>
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// src/components/equity/equityPlaceorder.vue